<template>
  <div v-loading="isLogining"></div>
</template>

<script>
import { getCookie } from "@/store/utils";
import _ from 'lodash'
export default {
  name: "ValidUser",
  data() {
    return {
      isLogining: false
    }
  },
  methods: {
    async validUserInfo() {
      try{
        this.isLogining = true
        let userData = await this.POST_AD_FIND_LOGIN_USERINFO({
          adminUserKey: getCookie("AdminUserKey"),
          adminUserToken: getCookie("AdminUserToken"),
        });
        this.isLogining = false
        if (userData) {
          this.$store.dispatch("login", userData);
          await this.POST_AD_FIND_LOGIN_BRANDS({
            userId: userData.id
          })
          if(!window.sessionStorage.getItem('powerRouterList') || JSON.parse(window.sessionStorage.getItem('powerRouterList')).length == 0) {
            let powerResp = await this.$store.dispatch('getPowerRouterList', userData.id)
            this.$store.dispatch("savePowerRouterList", powerResp);
          } else {
            this.$store.dispatch('savePowerRouterList', JSON.parse(window.sessionStorage.getItem('powerRouterList')))
            this.$store.commit('SETSCHEDULE', JSON.parse(window.sessionStorage.getItem('schedulePageList')))
          }
        } else {
          this.$router.push("/login");
          this.$store.dispatch("logout", this.$store.state.userInfo.id);
        }
      }catch(error) {}
    },
    POST_AD_FIND_LOGIN_BRANDS(params) {
      return new Promise((resolve, reject) => {
        this.$apis.autoAPi
          .POST_AD_FIND_LOGIN_BRANDS(params)
          .done((resp) => {
            if (resp.oK == true) {
              this.$store.commit('setUserBrandCodeList', resp.data.map(item => item.brandCode))
              resolve(resp.data);
            }
          })
          .fail((err) => {
            resolve(false);
          });
      });
    },
    POST_AD_FIND_LOGIN_USERINFO(params) {
      return new Promise((resolve, reject) => {
        this.$apis.autoAPi
          .POST_AD_FIND_LOGIN_USERINFO(params)
          .done((resp) => {
            if (resp.oK == true) {
              resolve(resp.data);
            } else {
              resolve(false)
            }
          })
          .fail((err) => {
            resolve(false);
          });
      });
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.$store.dispatch('login', {})
    // }, 2000);
    // 添加不需要校验登录状态的页面 // todo
    this.validUserInfo();
  },
};
</script>